import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ExpensesModelDto } from './expenses-model';
export class ExpensesResponseModel extends GlobalResponseObject{
    data?: ExpensesModelDto[];

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ExpensesModelDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
}
}
